import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalDropdown {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  DropdownLists?: any;
}

const initialState: GlobalDropdown = {
  isLoading: false,
  error: false,
  message: null,
  DropdownLists: [],
};

const GlobalDropdownSlice = createSlice({
  name: "GlobalDropdown",
  initialState,
  reducers: {
    loadingGlobalDropdown: (state: GlobalDropdown, action: PayloadAction) => {
      state.isLoading = true;
    },
    setGlobalDropdown: (state: any, action: PayloadAction<GlobalDropdown>) => {
      return action.payload;
    },
    clearData: (state: GlobalDropdown, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingGlobalDropdown, setGlobalDropdown, clearData } =
  GlobalDropdownSlice.actions;

export default GlobalDropdownSlice.reducer;
